/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as CrashRouteImport } from './routes/crash'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as AuthenticatedAuditLogRouteImport } from './routes/_authenticated/audit-log'
import { Route as AuthenticatedCampaignRouteImport } from './routes/_authenticated/campaign'
import { Route as AuthenticatedChangePasswordRouteImport } from './routes/_authenticated/change-password'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedExportOrdersRouteImport } from './routes/_authenticated/export-orders'
import { Route as AuthenticatedInboundReportRouteImport } from './routes/_authenticated/inbound-report'
import { Route as AuthenticatedInventoryRouteImport } from './routes/_authenticated/inventory'
import { Route as AuthenticatedInventoryDiffRouteImport } from './routes/_authenticated/inventory-diff'
import { Route as AuthenticatedInventoryRatioRouteImport } from './routes/_authenticated/inventory-ratio'
import { Route as AuthenticatedManualReviewRouteImport } from './routes/_authenticated/manual-review'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedOrdersRouteImport } from './routes/_authenticated/orders'
import { Route as AuthenticatedOrdersExportRouteImport } from './routes/_authenticated/orders-export'
import { Route as AuthenticatedPromotionRouteImport } from './routes/_authenticated/promotion'
import { Route as AuthenticatedPromotionReportRouteImport } from './routes/_authenticated/promotion-report'
import { Route as AuthenticatedReturnsRouteImport } from './routes/_authenticated/returns'
import { Route as AuthenticatedRevenueReportRouteImport } from './routes/_authenticated/revenue-report'
import { Route as AuthenticatedSplitOrdersRouteImport } from './routes/_authenticated/split-orders'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedOrdersSaleOrderIdRouteImport } from './routes/_authenticated/orders_.$saleOrderId'
import { Route as AuthenticatedPromotionPromotionIdRouteImport } from './routes/_authenticated/promotion_.$promotionId'
import { Route as AuthenticatedSettingsMarketplaceConnectionsRouteImport } from './routes/_authenticated/settings.marketplace-connections'
import { Route as AuthenticatedSettingsSkuBrandsRouteImport } from './routes/_authenticated/settings.sku-brands'
import { Route as AuthenticatedSplitOrdersSaleOrderIdRouteImport } from './routes/_authenticated/split-orders_.$saleOrderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const CrashRoute = CrashRouteImport.update({
  id: '/crash',
  path: '/crash',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAuditLogRoute = AuthenticatedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCampaignRoute = AuthenticatedCampaignRouteImport.update({
  id: '/campaign',
  path: '/campaign',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChangePasswordRoute =
  AuthenticatedChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExportOrdersRoute =
  AuthenticatedExportOrdersRouteImport.update({
    id: '/export-orders',
    path: '/export-orders',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInboundReportRoute =
  AuthenticatedInboundReportRouteImport.update({
    id: '/inbound-report',
    path: '/inbound-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryRoute = AuthenticatedInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInventoryDiffRoute =
  AuthenticatedInventoryDiffRouteImport.update({
    id: '/inventory-diff',
    path: '/inventory-diff',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryRatioRoute =
  AuthenticatedInventoryRatioRouteImport.update({
    id: '/inventory-ratio',
    path: '/inventory-ratio',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManualReviewRoute =
  AuthenticatedManualReviewRouteImport.update({
    id: '/manual-review',
    path: '/manual-review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrdersRoute = AuthenticatedOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrdersExportRoute =
  AuthenticatedOrdersExportRouteImport.update({
    id: '/orders-export',
    path: '/orders-export',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromotionRoute = AuthenticatedPromotionRouteImport.update({
  id: '/promotion',
  path: '/promotion',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromotionReportRoute =
  AuthenticatedPromotionReportRouteImport.update({
    id: '/promotion-report',
    path: '/promotion-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReturnsRoute = AuthenticatedReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRevenueReportRoute =
  AuthenticatedRevenueReportRouteImport.update({
    id: '/revenue-report',
    path: '/revenue-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSplitOrdersRoute =
  AuthenticatedSplitOrdersRouteImport.update({
    id: '/split-orders',
    path: '/split-orders',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrdersSaleOrderIdRoute =
  AuthenticatedOrdersSaleOrderIdRouteImport.update({
    id: '/orders_/$saleOrderId',
    path: '/orders/$saleOrderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromotionPromotionIdRoute =
  AuthenticatedPromotionPromotionIdRouteImport.update({
    id: '/promotion_/$promotionId',
    path: '/promotion/$promotionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMarketplaceConnectionsRoute =
  AuthenticatedSettingsMarketplaceConnectionsRouteImport.update({
    id: '/settings/marketplace-connections',
    path: '/settings/marketplace-connections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsSkuBrandsRoute =
  AuthenticatedSettingsSkuBrandsRouteImport.update({
    id: '/settings/sku-brands',
    path: '/settings/sku-brands',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSplitOrdersSaleOrderIdRoute =
  AuthenticatedSplitOrdersSaleOrderIdRouteImport.update({
    id: '/split-orders_/$saleOrderId',
    path: '/split-orders/$saleOrderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/crash': typeof CrashRoute
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/campaign': typeof AuthenticatedCampaignRoute
  '/change-password': typeof AuthenticatedChangePasswordRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/export-orders': typeof AuthenticatedExportOrdersRoute
  '/inbound-report': typeof AuthenticatedInboundReportRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/inventory-diff': typeof AuthenticatedInventoryDiffRoute
  '/inventory-ratio': typeof AuthenticatedInventoryRatioRoute
  '/manual-review': typeof AuthenticatedManualReviewRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/orders': typeof AuthenticatedOrdersRoute
  '/orders-export': typeof AuthenticatedOrdersExportRoute
  '/promotion': typeof AuthenticatedPromotionRoute
  '/promotion-report': typeof AuthenticatedPromotionReportRoute
  '/returns': typeof AuthenticatedReturnsRoute
  '/revenue-report': typeof AuthenticatedRevenueReportRoute
  '/split-orders': typeof AuthenticatedSplitOrdersRoute
  '/users': typeof AuthenticatedUsersRoute
  '/orders/$saleOrderId': typeof AuthenticatedOrdersSaleOrderIdRoute
  '/promotion/$promotionId': typeof AuthenticatedPromotionPromotionIdRoute
  '/settings/marketplace-connections': typeof AuthenticatedSettingsMarketplaceConnectionsRoute
  '/settings/sku-brands': typeof AuthenticatedSettingsSkuBrandsRoute
  '/split-orders/$saleOrderId': typeof AuthenticatedSplitOrdersSaleOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/crash': typeof CrashRoute
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/campaign': typeof AuthenticatedCampaignRoute
  '/change-password': typeof AuthenticatedChangePasswordRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/export-orders': typeof AuthenticatedExportOrdersRoute
  '/inbound-report': typeof AuthenticatedInboundReportRoute
  '/inventory': typeof AuthenticatedInventoryRoute
  '/inventory-diff': typeof AuthenticatedInventoryDiffRoute
  '/inventory-ratio': typeof AuthenticatedInventoryRatioRoute
  '/manual-review': typeof AuthenticatedManualReviewRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/orders': typeof AuthenticatedOrdersRoute
  '/orders-export': typeof AuthenticatedOrdersExportRoute
  '/promotion': typeof AuthenticatedPromotionRoute
  '/promotion-report': typeof AuthenticatedPromotionReportRoute
  '/returns': typeof AuthenticatedReturnsRoute
  '/revenue-report': typeof AuthenticatedRevenueReportRoute
  '/split-orders': typeof AuthenticatedSplitOrdersRoute
  '/users': typeof AuthenticatedUsersRoute
  '/orders/$saleOrderId': typeof AuthenticatedOrdersSaleOrderIdRoute
  '/promotion/$promotionId': typeof AuthenticatedPromotionPromotionIdRoute
  '/settings/marketplace-connections': typeof AuthenticatedSettingsMarketplaceConnectionsRoute
  '/settings/sku-brands': typeof AuthenticatedSettingsSkuBrandsRoute
  '/split-orders/$saleOrderId': typeof AuthenticatedSplitOrdersSaleOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/crash': typeof CrashRoute
  '/login': typeof LoginRoute
  '/playground': typeof PlaygroundRoute
  '/_authenticated/audit-log': typeof AuthenticatedAuditLogRoute
  '/_authenticated/campaign': typeof AuthenticatedCampaignRoute
  '/_authenticated/change-password': typeof AuthenticatedChangePasswordRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/export-orders': typeof AuthenticatedExportOrdersRoute
  '/_authenticated/inbound-report': typeof AuthenticatedInboundReportRoute
  '/_authenticated/inventory': typeof AuthenticatedInventoryRoute
  '/_authenticated/inventory-diff': typeof AuthenticatedInventoryDiffRoute
  '/_authenticated/inventory-ratio': typeof AuthenticatedInventoryRatioRoute
  '/_authenticated/manual-review': typeof AuthenticatedManualReviewRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/orders': typeof AuthenticatedOrdersRoute
  '/_authenticated/orders-export': typeof AuthenticatedOrdersExportRoute
  '/_authenticated/promotion': typeof AuthenticatedPromotionRoute
  '/_authenticated/promotion-report': typeof AuthenticatedPromotionReportRoute
  '/_authenticated/returns': typeof AuthenticatedReturnsRoute
  '/_authenticated/revenue-report': typeof AuthenticatedRevenueReportRoute
  '/_authenticated/split-orders': typeof AuthenticatedSplitOrdersRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/orders_/$saleOrderId': typeof AuthenticatedOrdersSaleOrderIdRoute
  '/_authenticated/promotion_/$promotionId': typeof AuthenticatedPromotionPromotionIdRoute
  '/_authenticated/settings/marketplace-connections': typeof AuthenticatedSettingsMarketplaceConnectionsRoute
  '/_authenticated/settings/sku-brands': typeof AuthenticatedSettingsSkuBrandsRoute
  '/_authenticated/split-orders_/$saleOrderId': typeof AuthenticatedSplitOrdersSaleOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/crash'
    | '/login'
    | '/playground'
    | '/audit-log'
    | '/campaign'
    | '/change-password'
    | '/dashboard'
    | '/export-orders'
    | '/inbound-report'
    | '/inventory'
    | '/inventory-diff'
    | '/inventory-ratio'
    | '/manual-review'
    | '/notifications'
    | '/orders'
    | '/orders-export'
    | '/promotion'
    | '/promotion-report'
    | '/returns'
    | '/revenue-report'
    | '/split-orders'
    | '/users'
    | '/orders/$saleOrderId'
    | '/promotion/$promotionId'
    | '/settings/marketplace-connections'
    | '/settings/sku-brands'
    | '/split-orders/$saleOrderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/crash'
    | '/login'
    | '/playground'
    | '/audit-log'
    | '/campaign'
    | '/change-password'
    | '/dashboard'
    | '/export-orders'
    | '/inbound-report'
    | '/inventory'
    | '/inventory-diff'
    | '/inventory-ratio'
    | '/manual-review'
    | '/notifications'
    | '/orders'
    | '/orders-export'
    | '/promotion'
    | '/promotion-report'
    | '/returns'
    | '/revenue-report'
    | '/split-orders'
    | '/users'
    | '/orders/$saleOrderId'
    | '/promotion/$promotionId'
    | '/settings/marketplace-connections'
    | '/settings/sku-brands'
    | '/split-orders/$saleOrderId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/crash'
    | '/login'
    | '/playground'
    | '/_authenticated/audit-log'
    | '/_authenticated/campaign'
    | '/_authenticated/change-password'
    | '/_authenticated/dashboard'
    | '/_authenticated/export-orders'
    | '/_authenticated/inbound-report'
    | '/_authenticated/inventory'
    | '/_authenticated/inventory-diff'
    | '/_authenticated/inventory-ratio'
    | '/_authenticated/manual-review'
    | '/_authenticated/notifications'
    | '/_authenticated/orders'
    | '/_authenticated/orders-export'
    | '/_authenticated/promotion'
    | '/_authenticated/promotion-report'
    | '/_authenticated/returns'
    | '/_authenticated/revenue-report'
    | '/_authenticated/split-orders'
    | '/_authenticated/users'
    | '/_authenticated/orders_/$saleOrderId'
    | '/_authenticated/promotion_/$promotionId'
    | '/_authenticated/settings/marketplace-connections'
    | '/_authenticated/settings/sku-brands'
    | '/_authenticated/split-orders_/$saleOrderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CrashRoute: typeof CrashRoute
  LoginRoute: typeof LoginRoute
  PlaygroundRoute: typeof PlaygroundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crash': {
      id: '/crash'
      path: '/crash'
      fullPath: '/crash'
      preLoaderRoute: typeof CrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/audit-log': {
      id: '/_authenticated/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthenticatedAuditLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign': {
      id: '/_authenticated/campaign'
      path: '/campaign'
      fullPath: '/campaign'
      preLoaderRoute: typeof AuthenticatedCampaignRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/change-password': {
      id: '/_authenticated/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthenticatedChangePasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/export-orders': {
      id: '/_authenticated/export-orders'
      path: '/export-orders'
      fullPath: '/export-orders'
      preLoaderRoute: typeof AuthenticatedExportOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbound-report': {
      id: '/_authenticated/inbound-report'
      path: '/inbound-report'
      fullPath: '/inbound-report'
      preLoaderRoute: typeof AuthenticatedInboundReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory': {
      id: '/_authenticated/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthenticatedInventoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory-diff': {
      id: '/_authenticated/inventory-diff'
      path: '/inventory-diff'
      fullPath: '/inventory-diff'
      preLoaderRoute: typeof AuthenticatedInventoryDiffRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory-ratio': {
      id: '/_authenticated/inventory-ratio'
      path: '/inventory-ratio'
      fullPath: '/inventory-ratio'
      preLoaderRoute: typeof AuthenticatedInventoryRatioRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/manual-review': {
      id: '/_authenticated/manual-review'
      path: '/manual-review'
      fullPath: '/manual-review'
      preLoaderRoute: typeof AuthenticatedManualReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders': {
      id: '/_authenticated/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders-export': {
      id: '/_authenticated/orders-export'
      path: '/orders-export'
      fullPath: '/orders-export'
      preLoaderRoute: typeof AuthenticatedOrdersExportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotion': {
      id: '/_authenticated/promotion'
      path: '/promotion'
      fullPath: '/promotion'
      preLoaderRoute: typeof AuthenticatedPromotionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotion-report': {
      id: '/_authenticated/promotion-report'
      path: '/promotion-report'
      fullPath: '/promotion-report'
      preLoaderRoute: typeof AuthenticatedPromotionReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/returns': {
      id: '/_authenticated/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof AuthenticatedReturnsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/revenue-report': {
      id: '/_authenticated/revenue-report'
      path: '/revenue-report'
      fullPath: '/revenue-report'
      preLoaderRoute: typeof AuthenticatedRevenueReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/split-orders': {
      id: '/_authenticated/split-orders'
      path: '/split-orders'
      fullPath: '/split-orders'
      preLoaderRoute: typeof AuthenticatedSplitOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/orders_/$saleOrderId': {
      id: '/_authenticated/orders_/$saleOrderId'
      path: '/orders/$saleOrderId'
      fullPath: '/orders/$saleOrderId'
      preLoaderRoute: typeof AuthenticatedOrdersSaleOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotion_/$promotionId': {
      id: '/_authenticated/promotion_/$promotionId'
      path: '/promotion/$promotionId'
      fullPath: '/promotion/$promotionId'
      preLoaderRoute: typeof AuthenticatedPromotionPromotionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/marketplace-connections': {
      id: '/_authenticated/settings/marketplace-connections'
      path: '/settings/marketplace-connections'
      fullPath: '/settings/marketplace-connections'
      preLoaderRoute: typeof AuthenticatedSettingsMarketplaceConnectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/sku-brands': {
      id: '/_authenticated/settings/sku-brands'
      path: '/settings/sku-brands'
      fullPath: '/settings/sku-brands'
      preLoaderRoute: typeof AuthenticatedSettingsSkuBrandsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/split-orders_/$saleOrderId': {
      id: '/_authenticated/split-orders_/$saleOrderId'
      path: '/split-orders/$saleOrderId'
      fullPath: '/split-orders/$saleOrderId'
      preLoaderRoute: typeof AuthenticatedSplitOrdersSaleOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAuditLogRoute: typeof AuthenticatedAuditLogRoute
  AuthenticatedCampaignRoute: typeof AuthenticatedCampaignRoute
  AuthenticatedChangePasswordRoute: typeof AuthenticatedChangePasswordRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedExportOrdersRoute: typeof AuthenticatedExportOrdersRoute
  AuthenticatedInboundReportRoute: typeof AuthenticatedInboundReportRoute
  AuthenticatedInventoryRoute: typeof AuthenticatedInventoryRoute
  AuthenticatedInventoryDiffRoute: typeof AuthenticatedInventoryDiffRoute
  AuthenticatedInventoryRatioRoute: typeof AuthenticatedInventoryRatioRoute
  AuthenticatedManualReviewRoute: typeof AuthenticatedManualReviewRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOrdersRoute: typeof AuthenticatedOrdersRoute
  AuthenticatedOrdersExportRoute: typeof AuthenticatedOrdersExportRoute
  AuthenticatedPromotionRoute: typeof AuthenticatedPromotionRoute
  AuthenticatedPromotionReportRoute: typeof AuthenticatedPromotionReportRoute
  AuthenticatedReturnsRoute: typeof AuthenticatedReturnsRoute
  AuthenticatedRevenueReportRoute: typeof AuthenticatedRevenueReportRoute
  AuthenticatedSplitOrdersRoute: typeof AuthenticatedSplitOrdersRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedOrdersSaleOrderIdRoute: typeof AuthenticatedOrdersSaleOrderIdRoute
  AuthenticatedPromotionPromotionIdRoute: typeof AuthenticatedPromotionPromotionIdRoute
  AuthenticatedSettingsMarketplaceConnectionsRoute: typeof AuthenticatedSettingsMarketplaceConnectionsRoute
  AuthenticatedSettingsSkuBrandsRoute: typeof AuthenticatedSettingsSkuBrandsRoute
  AuthenticatedSplitOrdersSaleOrderIdRoute: typeof AuthenticatedSplitOrdersSaleOrderIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditLogRoute: AuthenticatedAuditLogRoute,
  AuthenticatedCampaignRoute: AuthenticatedCampaignRoute,
  AuthenticatedChangePasswordRoute: AuthenticatedChangePasswordRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedExportOrdersRoute: AuthenticatedExportOrdersRoute,
  AuthenticatedInboundReportRoute: AuthenticatedInboundReportRoute,
  AuthenticatedInventoryRoute: AuthenticatedInventoryRoute,
  AuthenticatedInventoryDiffRoute: AuthenticatedInventoryDiffRoute,
  AuthenticatedInventoryRatioRoute: AuthenticatedInventoryRatioRoute,
  AuthenticatedManualReviewRoute: AuthenticatedManualReviewRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOrdersRoute: AuthenticatedOrdersRoute,
  AuthenticatedOrdersExportRoute: AuthenticatedOrdersExportRoute,
  AuthenticatedPromotionRoute: AuthenticatedPromotionRoute,
  AuthenticatedPromotionReportRoute: AuthenticatedPromotionReportRoute,
  AuthenticatedReturnsRoute: AuthenticatedReturnsRoute,
  AuthenticatedRevenueReportRoute: AuthenticatedRevenueReportRoute,
  AuthenticatedSplitOrdersRoute: AuthenticatedSplitOrdersRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedOrdersSaleOrderIdRoute: AuthenticatedOrdersSaleOrderIdRoute,
  AuthenticatedPromotionPromotionIdRoute:
    AuthenticatedPromotionPromotionIdRoute,
  AuthenticatedSettingsMarketplaceConnectionsRoute:
    AuthenticatedSettingsMarketplaceConnectionsRoute,
  AuthenticatedSettingsSkuBrandsRoute: AuthenticatedSettingsSkuBrandsRoute,
  AuthenticatedSplitOrdersSaleOrderIdRoute:
    AuthenticatedSplitOrdersSaleOrderIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CrashRoute: CrashRoute,
  LoginRoute: LoginRoute,
  PlaygroundRoute: PlaygroundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
